import { render, staticRenderFns } from "./shooting_star.vue?vue&type=template&id=b138c996"
import script from "./shooting_star.vue?vue&type=script&lang=js"
export * from "./shooting_star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports